import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import {
  MID,
  NOT_WIDE,
  TINY,
  marketingPalette,
} from "@/components/marketing/tokens";
import { ActionButton, SectionContainer } from "./HomePrimitives";
import WhyDashboard from "./WhyDashboard";
import WhyDeveloper from "./WhyDeveloper";
import WhyReliable from "./WhyReliable";
import WhySupport from "./WhySupport";
import { DASHBOARD } from "./homeContent";
import { HEADING_3 } from "./homeType";

/**
 * Four blocks in one `<section>`, which is how the published page ships them:
 * 2913px at 1440 and 5171px at 767. Kept as one section so the DOM contract
 * holds, and split into four children so each is a file you can read.
 */
export default function WhySection() {
  return (
    <SectionContainer padding="both">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "6.25rem",
          [NOT_WIDE]: { gap: "4rem" },
          [MID]: { gap: "3rem" },
        }}
      >
        <WhyReliable />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "6.25rem",
            borderLeft: "1px dotted #B6B8C3",
            borderRight: "1px dotted #B6B8C3",
            // The rules stay down to the card step; the gap closes twice.
            [NOT_WIDE]: { gap: "4rem" },
            [MID]: { borderLeft: "none", borderRight: "none" },
            [TINY]: { gap: "3rem" },
          }}
        >
          <WhySupport />
          <WhyDeveloper />
          <Box>
            <WhyDashboard />
            <Box
              sx={{
                position: "relative",
                zIndex: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "2rem",
                maxWidth: "50.8rem",
                // Lifts the bar into the gradient at the foot of the tab visual
                // above it, which is the overlap the published page draws.
                mt: "-4rem",
                mx: "auto",
                p: "12px 12px 12px 16px",
                borderRadius: "1rem",
                backgroundColor: marketingPalette.darkGround,
                [NOT_WIDE]: { width: "95%" },
                [MID]: {
                  flexDirection: "column",
                  gap: "1rem",
                  width: "96%",
                  p: "16px 32px",
                  textAlign: "center",
                },
                [TINY]: { alignItems: "stretch", mt: "-1rem" },
              }}
            >
              <Typography component="h3" sx={HEADING_3}>
                {DASHBOARD.cta.heading}
                <Box component="span" sx={{ color: marketingPalette.mint }}>
                  {DASHBOARD.cta.highlight}
                </Box>
              </Typography>
              {/* `.button_new.is-why_web`: the heading gives way below the
                  wide step, never the control. */}
              <ActionButton
                cta={DASHBOARD.cta}
                width="hug"
                sx={{ [NOT_WIDE]: { flex: "none" } }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </SectionContainer>
  );
}
